module.exports = __webpack_public_path__ + "static/img/Visa.bd26faeb.svg";